import {apiUri} from "../../../config";
import {push} from 'connected-react-router'
import axios from "axios";

export const BUY_CASE = 'BUY_CASE';
export const LOAD_BOUGHT_CASES = 'LOAD_BOUGHT_CASES';
export const JUST_BOUGHT_RESET = 'JUST_BOUGHT_RESET';


const casesBought = (caseId) => {
    return ({
        type: BUY_CASE,
        boughtCase: caseId
    })
};

const loadCases = (data) => {
    return ({
        type: LOAD_BOUGHT_CASES,
        cases: data
    })
};

export const buyCase = (caseId, commissionLevel,subscription) => {

   var subscriptionType = subscription ? 'SUBSCRIBER' : 'NONSUBSCRIBER'
    return dispatch => {
        axios.post(apiUri + "/purchases/" + caseId + "?commissionLevel=" + commissionLevel + "&purchaseType="+ subscriptionType)
            .then(response => {
                dispatch(casesBought(caseId));
                if(!subscription) {
                    dispatch(push("/cases/" + caseId));
                } else {
                 dispatch(push("/cases/" + caseId + "/classwide"));
                }
            });
    }
};

export const requestCaseLoad = () => {
    return dispatch => {
        axios.get(apiUri + "/purchases")
            .then(cases => dispatch(loadCases(cases.data.content)))
    }

};

export const resetJustBought = () => {
    return {type: JUST_BOUGHT_RESET}
};


// WEBPACK FOOTER //
// ./src/components/Purchases/store/actions.js